<template>
  <el-main>
    <div v-html="productDetails.product_description"></div>
  </el-main>

</template>

<script>
export default {
  data(){
    return{
      productDetails:{}
    }
  },
  methods:{
    async getProductDetails() {
      const { data: res } = await this.$http.get(
        `/api/v2/product/${this.$route.params.id}`
      );
      // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.productDetails = res.data;
      setTimeout(()=>{
        this.$zhTran()
      },300)
    },
  },
  created(){
    this.getProductDetails()
  }
}
</script>

<style lang="less" scoped>
  .el-main {
    width: 700px;
    margin-top: 40px;
  }
  @media screen and (max-width: 768px){
  .el-main {
    width: 100%;
    padding: 0 20px;
    margin-top: 20px;
  }
}
</style>